import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgCorporateLawsuit(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M22.282 79.863h10.162v-49.54l-10.163 7.7v41.84Z" fill="#78B441" />
      <path
        d="M43.789 79.863H32.444v-49.54l11.345 4.42v45.12ZM66.241 21.25l34.506 20.09V98.06H66.241V21.25Z"
        fill="#007A5F"
      />
      <path d="M66.241 21.25 18.5 48.666V98.06h47.741V21.25Z" fill="#78B441" />
      <path
        d="M33.236 40.203a.8.8 0 0 0-1.092-.295l-10.281 5.904a.8.8 0 0 0 .796 1.388l10.282-5.905a.8.8 0 0 0 .295-1.092Z"
        fill="#007A5F"
      />
      <path d="m22.282 53.156 37.342-17.962V55.52L22.28 67.573V53.156Z" fill="#80CCB5" />
      <path
        d="m38.811 62.238-9.278 2.995v-7.59l9.278-3.887v8.482ZM48.841 40.466l10.783-5.015v9.529L48.84 49.493v-9.027Z"
        fill="#fff"
      />
      <path
        d="M48.041 58.897v-18.43a.8.8 0 1 1 1.6 0v18.43a.8.8 0 0 1-1.6 0ZM28.733 65.04V49.744a.8.8 0 1 1 1.6 0V65.04a.8.8 0 1 1-1.6 0ZM38.011 62.031v-16.8a.8.8 0 1 1 1.6 0v16.8a.8.8 0 0 1-1.6 0Z"
        fill="#599F40"
      />
      <path
        d="M59.318 44.485a.8.8 0 0 1 .612 1.479L22.587 61.418a.8.8 0 1 1-.611-1.478l37.342-15.455Z"
        fill="#599F40"
      />
      <path d="m22.282 75.759 10.162-2.127V87.34l-10.163.709v-12.29Z" fill="#fff" />
      <path
        d="M31.644 87.34V74.616l-9.198 1.926a.8.8 0 0 1-.329-1.567l10.164-2.126a.8.8 0 0 1 .963.783V87.34a.8.8 0 0 1-1.6 0Z"
        fill="#0F172A"
      />
      <path d="m41.448 71.355 18.199-4.018v30.725H41.448V71.355Z" fill="#599F40" />
      <path
        d="M43.325 82.342a1.003 1.003 0 0 1 2.006 0v4.012a1.003 1.003 0 1 1-2.006 0v-4.012ZM58.847 98.061V68.332L41.62 72.136a.8.8 0 0 1-.346-1.563l18.2-4.017a.8.8 0 0 1 .971.78v30.725a.8.8 0 1 1-1.6 0Z"
        fill="#0F172A"
      />
    </svg>
  )
}
export default wrapIllustration(SvgCorporateLawsuit)
